import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import Media from 'components/common/Media'

const ShopTiresButton = ({
  className,
  disabled,
  handleShopTiresClick,
  ...props
}) =>
  <CustomButton
    { ...props }
    className={ className }
    disabled={ disabled }
    onClick={ handleShopTiresClick } />

export default ShopTiresButton

ShopTiresButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleShopTiresClick: PropTypes.func
}

const CustomButton = styled(Button)`
  ${Media.mobile`
    margin-top: 15px;
  `}
`
